import { useRouter } from "next/router";
import Link from "next/link";
import { useEffect, useState } from "react";

const Nav = () => {
  const [mounted, setMounted] = useState(false);
  const router = useRouter();

  const isActive = (href) => router.pathname === href;

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <nav className="mainmenu-nav">
      <ul className="mainmenu">
        {/* <li>
          <Link href="/" className={isActive("/") ? "active" : ""}>
            Home
          </Link>
        </li> */}
      </ul>
    </nav>
  );
};

export default Nav;
